import _ from 'lodash';
import { Message } from 'iview';
import { queryBlackList } from '@/api/user';

const state = {
    isInBlackList: false,
    showBlackListModal: false,
    isUserLeadStatus: false,
    needCertification: true,
    certificationDate: 7,
    companyCertificationStatus: '',
    done: false,
    waitRegister: false,
    contractStatus: '',
    contractUrl: '',
    flowId: ''
};

// actions
const actions = {
    queryUserBlackList ({ commit }, payload) {
        return queryBlackList().then(res => {
            let flag = false;
            res.data.code == 'FAIL' ? flag = true : flag = false;
            commit('save', {
                isInBlackList: flag
            });
            return flag;
        });
    },
    validateBlackList ({ dispatch, commit }) {
        const cb = Message.loading('加载中...');
        return dispatch('queryUserBlackList').then(flag => {
            if (flag) {
                commit('save', {
                    showBlackListModal: true
                });
            }
            return flag;
        }).catch(() => {
            cb();
            // commit('save', {
            //     showBlackListModal: true
            // });
            return true;
        });
    }
};

// mutations
const mutations = {
    save (state, payload) {
        Object.assign(state, payload);
    },
    userLeadStatus (state, payload) {
        state.isUserLeadStatus = payload;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/stores/user.module.js